export default __webpack_public_path__ + "static/media/piscina2.ee98d118.jpg";